import { render, staticRenderFns } from "./CallNegoce.vue?vue&type=template&id=526de19b&scoped=true"
import script from "./CallNegoce.vue?vue&type=script&lang=js"
export * from "./CallNegoce.vue?vue&type=script&lang=js"
import style0 from "./CallNegoce.vue?vue&type=style&index=0&id=526de19b&prod&scoped=true&lang=css"
import style1 from "./CallNegoce.vue?vue&type=style&index=1&id=526de19b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526de19b",
  null
  
)

export default component.exports